// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2I3Ni","requiredAsterisk":"Info_requiredAsterisk__13vID"};